import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from '../../../utils/redux-injectors';
import { commonSaga } from './saga';
import { initialCommonState } from './types';

const commonSlice = createSlice({
  name: 'common',
  initialState: initialCommonState,
  reducers: {
    setReady(state, action: PayloadAction<boolean>) {
      state.ready = action.payload;
    },
  },
});

export const commonActions = commonSlice.actions;
export const commonReducer = commonSlice.reducer;
export { initialCommonState };

export function useCommonSlice() {
  useInjectReducer({ key: 'common', reducer: commonSlice.reducer });
  useInjectSaga({ key: 'common', saga: commonSaga });
  return { actions: commonSlice.actions };
}

export default commonSlice.reducer;
